import { Link } from 'react-router-dom';

const stats = [
  { value: '今日瓜点', label: '18 条' },
  { value: '蹲点记录', label: '6 条' },
  { value: '小队成员', label: '4 位' },
];

export default function HeroSection() {
  return (
    <section className="relative -mt-16 md:-mt-20 w-full min-h-[560px] md:min-h-[720px] flex items-center">
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20illustration%20of%20a%20lively%20crowd%20of%20onlookers%20gathering%20at%20dusk%2C%20soft%20amber%20and%20terracotta%20lantern%20lights%2C%20abstract%20painterly%20silhouettes%2C%20cozy%20festive%20atmosphere%2C%20muted%20cream%20and%20orange%20palette%2C%20subtle%20grain%2C%20cinematic%20wide%20composition&width=1600&height=1000&seq=511-hero-main&orientation=landscape"
          alt="511群众围观现场暖色调插画背景"
          title="511群众 · 抱团吃瓜围观前线"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-20 md:py-28">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/25 text-background-50 text-xs md:text-sm">
            <i className="ri-radar-line"></i>
            511群众 · 抱团围观阵地
          </div>

          <h1 className="mt-5 font-heading font-black text-3xl md:text-5xl lg:text-6xl leading-[1.15] text-white">
            抱团吃瓜
            <br />
            跟上围观的节奏
          </h1>

          <p className="mt-5 text-sm md:text-lg leading-relaxed text-background-100 max-w-xl">
            吃瓜小队蹲点汇总前线动态，把公开可见的现场见闻和热榜脉络整理成清晰的内容流。想看看群众都在关注什么，来这里就能同步最新瓜点。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Link
              to="/frontline"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-radar-line"></i>
              进入围观前线
            </Link>
            <a
              href="#hot-topics"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-white/10 backdrop-blur-sm border border-white/30 text-white font-medium hover:bg-white/20 transition-colors whitespace-nowrap"
            >
              <i className="ri-fire-line"></i>
              看今日热门瓜点
            </a>
          </div>

          <dl className="mt-10 flex flex-wrap gap-x-10 gap-y-4">
            {stats.map((item) => (
              <div key={item.value} className="flex flex-col">
                <dt className="text-xs text-background-200 tracking-wider">{item.value}</dt>
                <dd className="mt-1 font-heading font-bold text-xl md:text-2xl text-white">
                  {item.label}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}